import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import Navbar3 from '../../components/Navbar3/Navbar3';
import PrivacyPolicy from '../../components/PrivacyPolicy/PrivacyPolicy';
import CookiesPolicy from '../../components/CookiesPolicy/CookiesPolicy';

const CookiesPage = (props) => {


    return (
        <Fragment>
              <div
        style={{
          backgroundImage: `url('/img/solutionbg.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
             <Navbar3 topbarNone={"wpo-header-style-6"} />
            <PageTitle pageTitle={'Cookies Policy'} backgroundImage={require("../../images/ts.jpeg")}/> 
            <CookiesPolicy/>
            </div>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default CookiesPage;
